import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "data-set"
}
const _hoisted_2 = { class: "data-key body-text text-w-bold text-uppercase" }
const _hoisted_3 = {
  key: 0,
  class: "data-value body-text-md text-w-light"
}
const _hoisted_4 = {
  key: 1,
  class: "data-value"
}
const _hoisted_5 = ["href"]

import {computed} from 'vue'
import { NCard, NSpace, NTag, NButton, NIcon, NSkeleton } from 'naive-ui'
import { OpenInNewFilled } from '@vicons/material'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsCard',
  props: [
  'title',
  'detailsStructure',
  'data'
],
  emits: ['closeCard'],
  setup(__props) {

const props = __props



const loading = computed(() => {
  return typeof props.data == 'undefined'
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    size: "huge",
    title: __props.title ?? 'Details',
    closable: "",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeCard'))),
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NSpace), {
        size: 30,
        vertical: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detailsStructure, (field, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (typeof __props.data != 'undefined' && __props.data[field.key] && __props.data[field.key].length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_unref(NSpace), {
                      size: "small",
                      vertical: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(field.label), 1),
                        (loading.value)
                          ? (_openBlock(), _createBlock(_unref(NSkeleton), {
                              key: 0,
                              height: "28px",
                              width: "100%",
                              sharp: false
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (field.type === 'string')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.data[field.key]), 1))
                                : (field.type === 'object')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_unref(NSpace), null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data[field.key], (skill, key) => {
                                            return (_openBlock(), _createBlock(_unref(NTag), {
                                              key: key,
                                              type: "info",
                                              bordered: false
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(skill.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (field.type === 'link')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        class: "data-value simple-link",
                                        href: __props.data[field.key],
                                        target: "_blank"
                                      }, [
                                        _createVNode(_unref(NButton), {
                                          tertiary: "",
                                          class: "width-50",
                                          focusable: false,
                                          size: "small",
                                          "icon-placement": "right"
                                        }, {
                                          icon: _withCtx(() => [
                                            _createVNode(_unref(NIcon), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(OpenInNewFilled))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(" Open link ")
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_5))
                                    : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})